import { MathUtils } from 'three'

export const MQ_TABLET = `${768 / 16}em`
export const ASPECT_RATIO_PORTRAIT = 9 / 16
export const ASPECT_RATIO_LANDSCAPE = 16 / 9
export const ANGLE_LANDSCAPE = 35
export const ANGLE_PORTRAIT = 12
export const TAN_LANDSCAPE = Math.tan(MathUtils.degToRad(ANGLE_LANDSCAPE))
export const TAN_PORTRAIT = Math.tan(MathUtils.degToRad(ANGLE_PORTRAIT))
export const BLUR = 0.05
export const GALLERY_SCALE_DURATION = 4000
export const GALLERY_FADE_DURATION = 750

export const COLORS = {
	WHITE: [1, 1, 1, 1],
	BLACK: [0, 0, 0, 0.75]
}

export const MODE = {
	LANDSCAPE: 'landscape',
	PORTRAIT: 'portrait'
}

export const TYPES = {
	IMG: 'img',
	SHAPE: 'shape',
	SLIDES: 'slides',
	SECTION: 'section',
	INTRO_SECTION: 'intro_section',
	MASK: 'mask',
	MASK_SHAPE: 'mask_shape',
	BLUR_IMG: 'blur_img',
	VIDEO: 'video',
	DOM_IMG: 'dom_img'
}
